module.exports = __webpack_public_path__ + "media/images/xpass/icons/star-9d129d9d24a29992131a398caf1f7141.svg";